<template>
  <div>
    <form action="" class="md-layout" @submit.prevent="handleSubmit">
      <div class="md-layout-item">
        <md-card-content v-if="!sending">
          <!--                    <div class="md-layout-item">-->
          <!--                        <md-field :class="getValidationClass('apn')">-->
          <!--                            <label for="apn">APN</label>-->
          <!--                            <md-select v-model="form.apn" name="apn" id="apn">-->
          <!--                                <md-option :value="0">Vivo</md-option>-->
          <!--                                <md-option :value="1">OI</md-option>-->
          <!--                                <md-option :value="2">Claro</md-option>-->
          <!--                                <md-option :value="3">Tim</md-option>-->
          <!--                                <md-option :value="4">Algar</md-option>-->
          <!--                                <md-option :value="5">M2dataVivo</md-option>-->
          <!--                            </md-select>-->
          <!--                            <span class="md-error" v-if="$v.form.apn.required">Campo Obrigatório</span>-->
          <!--                        </md-field>-->
          <!--                    </div>-->

          <!--                    <div class="md-layout-item">-->
          <!--                        <md-field :class="getValidationClass('operadora')">-->
          <!--                            <label for="operadora">Operadora</label>-->
          <!--                            <md-select v-model="form.operadora" name="operadora" id="operadora">-->
          <!--                                <md-option :value="0">Vivo</md-option>-->
          <!--                                <md-option :value="1">OI</md-option>-->
          <!--                                <md-option :value="2">Claro</md-option>-->
          <!--                                <md-option :value="3">Tim</md-option>-->
          <!--                                <md-option :value="4">Algar</md-option>-->
          <!--                                <md-option :value="5">M2dataVivo</md-option>-->
          <!--                            </md-select>-->
          <!--                            <span class="md-error" v-if="$v.form.operadora.required">Campo Obrigatório</span>-->
          <!--                        </md-field>-->
          <!--                    </div>-->

          <div class="md-layout">
            <div class="md-layout-item">
              <span class="md-caption"> Versão </span>
              <br />
              <span> {{ equipamento.metadata.version || '-' }}</span>
            </div>
            <div class="md-layout-item">
              <span class="md-caption"> ICCID </span>
              <br />
              <span> {{ equipamento.metadata.iccid || '-' }}</span>
            </div>
          </div>
          <div class="md-layout">
            <div class="md-layout-item">
              <span class="md-caption"> Operadora </span>
              <br />
              <span> {{ equipamento.metadata.data.operadora || '-' }}</span>
            </div>
          </div>

          <div class="md-layout">
            <div class="md-layout-item">
              <span class="md-caption"> SSID </span>
              <br />
              <span> {{ equipamento.metadata.data.ssid || '-' }}</span>
            </div>

            <div class="md-layout-item">
              <span class="md-caption"> WIFI PASS </span>
              <br />
              <span> {{ equipamento.metadata.data.password_wifi || '-' }}</span>
            </div>
          </div>

          <FinalRedeEquipamentoConfig
            v-if="equipamento.equipamentoConfigTipo === 0"
            :config="equipamento.config"
            @change="handleInnerConfig"
          />

          <MotoBombaEquipamentoConfig
            v-if="equipamento.equipamentoConfigTipo === 1"
            :config="equipamento.config"
            @change="handleInnerConfig"
          />
        </md-card-content>

        <md-progress-bar v-if="sending" md-mode="indeterminate" />

        <md-card-actions>
          <md-button type="submit" class="md-primary" :disabled="sending">
            Salvar
          </md-button>
        </md-card-actions>
      </div>
    </form>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

import FinalRedeEquipamentoConfig from '@/components/equipamento/config/FinalRedeEquipamentoConfig.vue'
import MotoBombaEquipamentoConfig from '@/components/equipamento/config/MotoBombaEquipamentoConfig.vue'
import equipamentoMixin from '@/mixins/equipamento.mixin'
import http from '@/utils/http'

export default {
  name: 'GerenciarConfiguracaoEquipamento',
  components: { MotoBombaEquipamentoConfig, FinalRedeEquipamentoConfig },
  mixins: [validationMixin, equipamentoMixin],
  props: {
    equipamento: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      sending: false,
      form: {
        apn: 0,
        operadora: 0,
        specificConfig: {},
      },
      innerFormValid: true,
    }
  },
  validations: {
    form: {
      apn: {
        required,
      },
      operadora: {
        required,
      },
    },
  },
  beforeMount() {
    this.form.apn = this.getConfigValue(
      this.equipamento.config,
      'ApnConfig',
      'tipo',
      0
    )
    this.form.operadora = this.getConfigValue(
      this.equipamento.config,
      'OperadoraConfig',
      'tipo',
      0
    )
  },
  methods: {
    handleInnerConfig(event) {
      this.form.specificConfig = event.form
      this.innerFormValid = event.valid
    },
    async handleSubmit() {
      this.$v.$touch()

      if (this.$v.$invalid || this.innerFormValid === false) {
        return
      }

      this.sending = true

      await http.post('equipamento/config', {
        equipamentoId: this.equipamento.id,
        config: {
          ApnConfig: {
            tipo: this.form.apn,
          },
          OperadoraConfig: {
            tipo: this.form.operadora,
          },
          MetadataConfig: {},
          ...this.form.specificConfig,
        },
      })

      this.sending = false

      this.$emit('update')
    },
  },
}
</script>

<style scoped lang="scss"></style>
